import { pdfjs } from 'react-pdf';
import { JPG_IMAGE_EXTENSION } from '../utils/constants';
import { jsPDF } from "jspdf";
import { PDFDocument } from 'pdf-lib';

import * as aws from './aws';

interface PDFParams {
	document: HTMLElement;
	onSuccess: (uri: string) => void;
}
const getPDFImageUrl = async (url: string): Promise<string[]> => {
	pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
	const pdfDocument = await pdfjs.getDocument(url).promise;
	const imageUrls: string[] = [];

	for (let i = 1; i <= pdfDocument.numPages; i++) {
		const newUrl = url
			.replace('pdf', JPG_IMAGE_EXTENSION)
			.replace('/upload/', `/upload/pg_${i}/`);
		imageUrls.push(newUrl);
	}

	return imageUrls;
};

const converhtmlToPdf = (params: PDFParams) => {
	var pdf = new jsPDF('p', 'pt', 'a4');
	pdf.html(params.document, {
		image: { type: 'jpeg', quality: 0.5 },
		autoPaging: 'text',
		callback: function (pdf) {
			pdf.save();

			const dataUri = pdf.output('datauristring');
			params.onSuccess(dataUri);
		}
	});
};

const mergePdfs = async (fileName: string, urls: string[]) => {
	const pdfDoc = await PDFDocument.create();

	for (const url of urls) {
		const result = await fetch(url);
		const arrayBuffer = await result.arrayBuffer();

		const document = await PDFDocument.load(arrayBuffer);
		const pageCount = document.getPageCount();

		for (let i = 0; i < pageCount; i++) {
			const [page] = await pdfDoc.copyPages(document, [i]);
			pdfDoc.addPage(page);
		}
	}
	
	const dataUri = await pdfDoc.saveAsBase64({ dataUri: true });
	await aws.uploadBase64ToS3(fileName, dataUri)
};

const removePages = async (fileName: string, url: string, startIndex: number) => {
	// rsidms.com/2024_RSG_EXX_ERH_EFVIP_HULL-DECK-MARINE-PART-3_398_1.pdf
	const result = await fetch(url);
	const arrayBuffer = await result.arrayBuffer();

	const document = await PDFDocument.load(arrayBuffer);
	const pageCount = document.getPageCount();
	
	for (let i = startIndex; i < pageCount; i++) {
		document.removePage(i);
	}

	const dataUri = await document.saveAsBase64({ dataUri: true });
	await aws.uploadBase64ToS3(fileName, dataUri);
};

const removeSinglePage = async (fileName: string, url: string, index: number) => {
	// rsidms.com/2024_RSG_EXX_ERH_EFVIP_HULL-DECK-MARINE-PART-3_398_1.pdf
	const result = await fetch(url);
	const arrayBuffer = await result.arrayBuffer();

	const document = await PDFDocument.load(arrayBuffer);
	document.removePage(index);
	
	const dataUri = await document.saveAsBase64({ dataUri: true });
	await aws.uploadBase64ToS3(fileName, dataUri);
};

const copySelectedPageRange = async (params: { fileName: string; url: string; startIndex: number; endIndex: number; }) => {
	const pdfDoc = await PDFDocument.create();

	const result = await fetch(params.url);
	const arrayBuffer = await result.arrayBuffer();
	const document = await PDFDocument.load(arrayBuffer);

	for (let i = params.startIndex; i < params.endIndex; i++) {
		const [page] = await pdfDoc.copyPages(document, [i]);
		pdfDoc.addPage(page);
	}
	
	const dataUri = await pdfDoc.saveAsBase64({ dataUri: true });
	await aws.uploadBase64ToS3(params.fileName, dataUri)
}

const pdfService = { copySelectedPageRange, getPDFImageUrl, converhtmlToPdf, mergePdfs, removePages, removeSinglePage };
export default pdfService;
